export default Object.freeze({
  /**
   * The video is hosted on Vimeo. This url should be played in a Vimeo player.
   */
  Vimeo: 'Vimeo',
  Youtube: 'Youtube',
  Bitmovin: 'Bitmovin',
})
